export default __webpack_public_path__ + "static/media/ExportNew.efcd3cc3.svg";